import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { times } from 'lodash';
import React, { FC } from 'react';
import './AssignmentsListSkeleton.scss';

export const AssignmentsListSkeleton: FC = () => {
  return (
    <ul className="assignmentsListSkeleton">
      {times(3, (index) => (
        <div key={index}>
          <Skeleton animation="wave">
            <SkeletonItem size={40} className="fullWidth" />
            {times(2, (innerIndex) => (
              <div key={`inner_${innerIndex}`} className="inner items-stretch">
                <div className="flex flex-col col justify-center gap-1">
                  <SkeletonItem size={16} className="width80" />
                  <SkeletonItem size={16} className="width50" />
                </div>
                <div className="flex flex-col col justify-center">
                  <SkeletonItem size={16} className="width70" />
                </div>
                <div className="last">
                  <SkeletonItem size={16} className="fullWidth" />
                </div>
              </div>
            ))}
          </Skeleton>
        </div>
      ))}
    </ul>
  );
};
